import SwipeOut from './SwipeOut';
import SwipeList from './SwipeList';

export {
	SwipeOut,
	SwipeList,
};



// WEBPACK FOOTER //
// ./node_modules/vue-swipe-actions/src/components/index.js